import { useAtom } from '@reatom/npm-react'

import { TradingControlsQuote } from '@root/features/trade/trading-controls/ui/common'

import type { Pair } from '@root/entities/pair'
import type { MarketSellControlsModel } from '@root/features/trade/trading-controls/atoms/common'

type Props = {
  pair: Pair.PairMinimal
  model: MarketSellControlsModel
}

export const InstantTradeSellQuote: React.FC<Props> = ({ pair, model }) => {
  const [quoteState] = useAtom(model.quoteModel.quoteStateAtom)

  return (
    <TradingControlsQuote
      swapDirection="sell"
      pair={pair}
      quoteState={quoteState}
    />
  )
}
